import { fetchSchemaRoutine } from 'app/branches/sagas/fetch-schema';
import { createRoutine } from 'app/common/utils/new-routines';
import { showMessage } from 'app/messages/actions';
import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { useWorkingCopyStore } from '../../branches/store/working-copy-store';
import { getSchemaVersion, restoreSchemaVersion } from '../api';
import type { GetSchemaVersionResponse } from './get-schema-version';
import { getSchemaHistoryRoutine } from './get-schema-version-list';

export type RestoreSchemaRequest = {
  version: number;
};

export type RestoreSchemaResponse = {
  version: number;
};

export const restoreSchemaRoutine = createRoutine('schema/RESTORE_SCHEMA')<
  undefined,
  RestoreSchemaRequest,
  undefined,
  RestoreSchemaResponse,
  string,
  undefined
>();

export function* restoreSchemaSaga(payload: RestoreSchemaRequest): SagaIterator {
  yield put(showMessage('info', 'Schema restoration started.', 3000));
  const restoredSchema: RestoreSchemaResponse = yield call(restoreSchemaVersion, payload);
  /* We need to poll for the new version to be saved and uploaded to S3,
  otherwise the schema returned by getSchemaVersion will be null! */
  let restoredSchemaData: GetSchemaVersionResponse = yield call(getSchemaVersion, restoredSchema);
  while (restoredSchemaData.status === 'Schema not found') {
    restoredSchemaData = yield call(getSchemaVersion, restoredSchema);
  }

  yield call(useWorkingCopyStore.getState().reset);
  yield put(fetchSchemaRoutine.requested(undefined, { runtime: false }));
  yield put(fetchSchemaRoutine.requested(undefined, { runtime: true }));
  yield put(getSchemaHistoryRoutine.requested({}));
  return restoredSchemaData;
}

export function* handleRestoreSchemaSagaFulfilled(): SagaIterator {
  yield put(showMessage('info', 'Schema successfully restored.', 3000));
}
